import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { useClosingOrdersStore } from '@ui/features/Websocket/useClosingOrdersStore';
import { useClosingTradesStore } from '@ui/features/Websocket/useClosingTradesStore';
import { usePendingLimitOrdersStore } from '@ui/features/Websocket/usePendingLimitOrdersStore';
import { usePendingTradesStore } from '@ui/features/Websocket/usePendingTradesStore';
import { useDataChainId } from '@ui/hooks/datachain';
import { useCallback } from 'react';
import { useSwitchChain as _useSwitchChain } from 'wagmi';

export const useSwitchChain = () => {
  const { switchChain, isPending } = _useSwitchChain();
  const currentChainId = useDataChainId();

  // reset limit order price
  const setInput = useFromInput((s) => s.setInput);
  const input = useFromInput((s) => s.input);

  const handleSwitchChain = useCallback(
    (chainId: number) => {
      // clear transient data for current chain only
      usePendingTradesStore.setState((state) => ({
        pendingTradesMap: {
          ...state.pendingTradesMap,
          [currentChainId]: [],
        },
      }));
      useClosingTradesStore.setState((state) => ({
        closingTradesMap: {
          ...state.closingTradesMap,
          [currentChainId]: [],
        },
      }));
      usePendingLimitOrdersStore.setState((state) => ({
        pendingLimitOrdersMap: {
          ...state.pendingLimitOrdersMap,
          [currentChainId]: [],
        },
      }));
      useClosingOrdersStore.setState((state) => ({
        closingOrdersMap: {
          ...state.closingOrdersMap,
          [currentChainId]: [],
        },
      }));

      switchChain({
        chainId,
      });
      // chain switch can make the trade pair changes and lead to trigger price not valid for user as well, change into default when switching chain
      setInput({
        ...input,
        triggerPrice: null,
      });
    },
    [switchChain, setInput, input, currentChainId],
  );

  return {
    switchChain: handleSwitchChain,
    isPending,
  };
};
